import { Interweave } from 'interweave';
import React from 'react';
import styled, { css } from 'styled-components';
import theme from '../../../constants/theme';

interface RichTextWrapperProps {
	isSmall: boolean;
	listItemIconUrl?: string;
}

export const RichTextWrapper = styled.div<RichTextWrapperProps>`
	font-size: ${({ isSmall }) => (isSmall ? 18 : 20)}px;
	font-weight: ${theme.fonts.weight.regular};
	line-height: ${({ isSmall }) => (isSmall ? 1.4 : 1.5)};
	font-family: ${theme.fonts.Arimo};
	color: ${theme.colorsV2.mainDark};
	letter-spacing: 0;

	ul {
		list-style-type: none !important;
		padding-inline-start: 32px;
	}

	ol {
		padding-inline-start: 32px;
	}

	ul li {
		position: relative;

		&:before {
			content: '';
			position: absolute;
			${({ listItemIconUrl }) =>
				!listItemIconUrl &&
				css`
					top: ${({ isSmall }) => (isSmall ? 8 : 11)}px;
					left: -24px;
					width: 8px;
					height: 8px;
					border-radius: 50%;
					background-color: ${theme.colorsV2.mainRed};
				`}
			${({ listItemIconUrl }) =>
				listItemIconUrl &&
				css`
					top: 0;
					left: -32px;
					width: 24px;
					height: 24px;
					background-image: url('${listItemIconUrl}');
					background-size: contain;
					background-repeat: no-repeat;
				`}
		}
	}

	a {
		cursor: pointer;
		color: ${theme.colorsV2.mainRed};
		transition: color 200ms ease;

		&:hover {
			color: ${theme.colorsV2.mainRed};
		}
	}

	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		line-height: 1.2;
	}

	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	strong {
		font-weight: ${theme.fonts.weight.bold};
	}

	em {
		font-style: italic;
	}

	blockquote {
		background-color: ${theme.colorsV2.grey2};
		padding: 8px;
		border-radius: 8px;
		font-style: italic;
	}

	img {
		height: auto;
		border-radius: 16px;

		&[align='left'],
		&[style*='float: left'],
		&[style*='float:left'] {
			margin-right: 16px;
			margin-bottom: 16px;
		}

		&[align='right'],
		&[style*='float: right'],
		&[style*='float:right'] {
			margin-left: 16px;
			margin-bottom: 16px;
		}
	}

	iframe {
		max-width: 100%;
		max-height: calc(100vw / (16 / 9));
	}

	* + h1,
	* + h2,
	* + h3,
	* + h4,
	* + h5,
	* + h6,
	* + blockquote,
	* + p,
	* + ul,
	* + ol,
	li + li,
	.embeditem {
		margin-top: 16px;
	}
`;

type TProps = {
	content: string;
	className?: string;
	isSmall?: boolean;
	listItemIconUrl?: string;
};

export const RichText = ({ content, className, isSmall = false, listItemIconUrl }: TProps) => (
	<RichTextWrapper className={className} isSmall={isSmall} listItemIconUrl={listItemIconUrl}>
		<Interweave
			content={content}
			tagName="fragment"
			allowElements
			onBeforeParse={content => {
				return content.replaceAll(/\s/g, ' ');
			}}
		/>
	</RichTextWrapper>
);

RichText.defaultProps = {
	className: '',
	isSmall: false,
	listItemIconUrl: '',
};
